module.exports = __webpack_public_path__ + "static/img/genomics_thumbnail.db4f842.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/genomics_thumbnail.jpg
// module id = CDh+
// module chunks = 6